import QRCode from 'qrcode';

export async function draw(
  canvas, companyName, qrcode,
  imgUrl, channelName, totalMoney) {
  // 生成二维码
  const qrImgDataUrl = await QRCode.toDataURL(qrcode);
  const qrImg = await getImg(qrImgDataUrl);

  const size = {
    width: qrImg.width + 160,
    height: qrImg.height + 260,
  };
  canvas.width = size.width;
  canvas.height = size.height;
  const ctx = canvas.getContext('2d');

  // 画红框
  ctx.fillStyle = 'rgb(247, 71, 73)';
  ctx.fillRect(0, 0, size.width, size.height - 90);
  // 公司名字
  ctx.font = '20px Arial';
  ctx.fillStyle = 'white';
  ctx.textAlign = 'center';
  ctx.fillText(companyName, size.width / 2, 50);
  // 画公司下面的虚线
  ctx.strokeStyle = 'white';
  ctx.beginPath();
  ctx.setLineDash([5]);
  ctx.moveTo(0, 70);
  ctx.lineTo(size.width, 70);
  ctx.stroke();
  // 画二维码外的白框
  ctx.fillStyle = 'white';
  ctx.fillRect(50, 100, size.width - 100, size.height - (220));
  ctx.fillRect(0, size.height - 90, size.width, 70);
  // 画入金金额
  ctx.font = '14px Arial';
  ctx.fillStyle = 'black';
  ctx.textAlign = 'center';
  ctx.fillText(totalMoney + '元', size.width / 2, 125);
  // 画二维码
  ctx.drawImage(qrImg, 80, 130);
  // 画支付渠道
  await drawChannel(ctx, imgUrl, size.width, size.height - 80, channelName);
  return size;
}
// 画支付渠道
function drawChannel(ctx, src, totalWidth, y, channelName) {
  return new Promise((resolve) => {

    // 画支付渠道 logo
    const img1 = new Image();
    img1.setAttribute('crossOrigin', 'anonymous');
    img1.src = src;
    img1.onload = function () {
      const channelNameWidth = channelName.length * 20 + 20;
      const imgX = (totalWidth - channelNameWidth - img1.width) / 2;
      ctx.drawImage(img1, imgX, y);
      // 画 文字

      ctx.font = '20px Arial';
      ctx.fillStyle = 'black';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      console.log(y, img1.height);

      ctx.fillText(channelName, imgX + img1.width,
        y + (img1.height / 2));

      resolve();
    };
  });
}
function getImg(src) {
  return new Promise<HTMLImageElement>((resolve) => {
    const img1 = new Image();
    img1.setAttribute('crossOrigin', 'anonymous');
    img1.src = src;
    img1.onload = function () {
      resolve(img1);
    };
  });
}



// WEBPACK FOOTER //
// ./src/utils/Draw.ts